import React, { useEffect, useRef, useState } from 'react';
import { useUnifiedFetch } from '../../hooks';
import { useSelector } from 'react-redux';
import { Input } from 'reactstrap';
import CustomModal from '../../components/CustomModal';
import SpinnerCircles from '../../components/Spinner/SpinerCircles';
const MODALS_DEFAULT = { boxes: false, serverId: '', error: false, errorText: '' };

const formatDate = dateToTransform => {
  const date = new Date(dateToTransform);

  return date.toLocaleString('en-US', { hour12: false });
};
export default function Servers() {
  const { isLoading, data, fetchData } = useUnifiedFetch(`users/servers`, true, true);
  const { data: events, fetchData: fetchEventData } = useUnifiedFetch(`users/events`, true, true);
  const { isLoading: boxesLoading, data: boxes, fetchData: fetchBoxes } = useUnifiedFetch(
    `users/servers/boxes`,
    false,
    true,
  );
  const tableBody = useRef(null);
  const [modals, setModals] = useState(MODALS_DEFAULT);
  return ( 
    <div>
      <div className="filter-section">
        <div className="fulfill-header">
          <Input
            style={{ width: 200 }}
            placeholder={'Search...'}
            onChange={e => {
              fetchData({ q: e.target.value });
              fetchEventData({ q: e.target.value });
            }}
          />
        </div>
      </div>
      <div hidden={!!!events?.length} className="viewContainer">
        Events
        <div style={{ height: "inherit" ,maxHeight:"50vh"}} className="table-header-fixed">
          <table>
            <thead className=" full-filltable-header">
              <tr className="full-filltable-row">
                <th>Date</th>
                <th>registrar</th>
                <th>Boxes</th>
                <th>Error</th>
              </tr>
            </thead>
            <tbody ref={tableBody} className="full-filltable-Body">
              {events?.map(item => {
                return (
                  <tr>
                    <td>{formatDate(item.createdOn)}</td>
                    <td>{item.ips?.join(', ')}</td>
                    <td
                      onClick={() => {
                        fetchBoxes({ eventId: item._id });
                        setModals({ boxes: true, eventId: item._id });
                      }}
                    >
                      {item.boxes}
                    </td>
                    <td
                      onClick={() => {
                        setModals({ error: true, errorText: item.errReason });
                      }}
                    >
                      {item.errReason.slice(0, 100)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <div className="viewContainer">
        Servers
        <div className="table-header-fixed">
          <table>
            <thead className=" full-filltable-header">
              <tr className="full-filltable-row">
                <th>IP</th>
                <th>registrar</th>
                <th>Online</th>
                <th>Boxes</th>
                <th>Error Text</th>
              </tr>
            </thead>
            <tbody ref={tableBody} className="full-filltable-Body">
              {isLoading ? (
                <></>
              ) : (
                data?.map(item => {
                  return (
                    <tr>
                      <td>{item.ip}</td>
                      <td>{item.type}</td>
                      <td>{item.online ? 'Online' : 'Offline'}</td>
                      <td
                        onClick={() => {
                          fetchBoxes({ serverId: item._id });
                          setModals({ boxes: true, serverId: item._id });
                        }}
                      >
                        {item.registrations}
                      </td>
                      <td
                        onClick={() => {
                          setModals({ error: true, errorText: item.errReason });
                        }}
                      >
                        {!item.online ? item.errReason ? item.errReason.slice(0, 100) : 'N/A' : 'N/A'}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>
      <CustomModal
        close
        onCancel={() => {
          setModals(MODALS_DEFAULT);
        }}
        isOpen={modals.error}
        bodyStyle={{ marginTop: 0 }}
      >
        <pre
          style={{
            whiteSpace: 'pre-wrap',
            wordWrap: 'break-word',
            background: '#f4f4f4',
            padding: '10px',
            borderRadius: '5px',
          }}
        >
          {modals.errorText}
        </pre>
      </CustomModal>
      <CustomModal
        close
        onCancel={() => {
          setModals(MODALS_DEFAULT);
        }}
        isOpen={modals.boxes}
        bodyStyle={{ marginTop: 0 }}
      >
        {
          <div className="table-header-fixed">
            <Input
              id="boxes"
              style={{ width: 200, marginBottom: 10 }}
              placeholder={'Search...'}
              onChange={e => {
                fetchBoxes({ ...modals, q: e.target.value });
              }}
            />
            <table>
              <thead className=" full-filltable-header">
                <tr className="full-filltable-row">
                  <th>Display Name</th>
                  <th>Serial Number</th>
                  <th>Vpn Address</th>
                  <th>Status</th>
                  <th>Datacenter</th>
                </tr>
              </thead>
              <tbody ref={tableBody} className="full-filltable-Body">
                {boxesLoading ? (
                  <SpinnerCircles red={true} />
                ) : (
                  boxes?.map(item => {
                    return (
                      <tr>
                        <td
                          onClick={() => {
                            window.open(
                              `${window.location.origin}/boxes/${item._id}?company=${item.assignedTo}`,
                              'blank',
                            );
                          }}
                        >
                          {item.displayName}
                        </td>
                        <td>{item.serialNumber}</td>
                        <td>{item.vpnAddress}</td>
                        <td>{item.registered ? 'Registered' : 'Unregistered'}</td>
                        <td>{item.datacenter}</td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        }
      </CustomModal>
    </div>
  );
}
